import type { TranslationMessages } from '../../types';

export const shift_bonus_config = 'Shift Bonus Config';
export const shift_bonus_config_desc = 'Configure bonuses for shifts';

export const bonus_config: TranslationMessages = {
  title: 'Shift Bonus Configuration',
  description:
    'Configure bonuses for different shift types. Bonuses can be based on position, time of day, or day of week.',
  add_config: 'Add Configuration',
  edit_config: 'Edit Bonus Configuration',
  config_name: 'Configuration Name',
  config_name_placeholder: 'e.g., Weekend Bonus',
  position: 'Position',
  all_positions: 'All Positions',
  time_of_day: 'Time of Day',
  any_time: 'Any Time',
  morning: 'Morning',
  afternoon: 'Afternoon',
  evening: 'Evening',
  night: 'Night',
  days_of_week: 'Days of Week',
  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  all_days_selected: 'Leave empty for all days',
  bonus_amount: 'Bonus Amount',
  currency: 'Currency',
  description_label: 'Description',
  description_placeholder: 'Optional description',
  conditions: 'Conditions',
  bonus: 'Bonus',
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  actions: 'Actions',
  cancel: 'Cancel',
  save: 'Save',
  loading: 'Loading...',
  load_error: 'Failed to load bonus configurations',
  save_success: 'Bonus configuration saved successfully',
  save_error: 'Failed to save bonus configuration',
  validation_error: 'Please fill in all required fields',
  delete_title: 'Delete Bonus Configuration',
  delete_confirm:
    'Are you sure you want to delete this configuration? This action cannot be undone.',
  delete: 'Delete',
  no_configs: 'No bonus configurations found. Add one to get started.',
  all_shifts: 'All Shifts',
  weekend_bonus: 'Weekend Bonus',
  weekend_bonus_desc: 'Bonus for working on weekends',
  night_shift_bonus: 'Night Shift Bonus',
  night_shift_bonus_desc: 'Bonus for night shifts',
  custom_time: 'Custom Time Range',
  custom_time_range: 'Custom Time Range',
  start_time: 'Start Time',
  end_time: 'End Time',
  custom_time_hint:
    'Set the time range for this bonus. Shifts that start within this range will receive the bonus.',
};
